"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exhaustiveCheck = void 0;
// See https://basarat.gitbooks.io/typescript/content/docs/types/discriminated-unions.html
// and https://github.com/Microsoft/TypeScript/issues/6155
function exhaustiveCheck(x, throwError, match) {
    if (throwError === void 0) { throwError = false; }
    if (match === void 0) { match = ""; }
    if (throwError) {
        throw new Error("ERROR! Trying to match '" + match + "', the value " + JSON.stringify(x) + " should be of type never.");
    }
    return x;
}
exports.exhaustiveCheck = exhaustiveCheck;
//# sourceMappingURL=exhaustive-check.js.map